import slugMap from "./blogSlugMap.json";
import { cleanBlogSlug, safeDecode } from "./blogSlug";

export function blogPath(rawSlug, title) {
  const clean = cleanBlogSlug(rawSlug, title);
  if (!clean) return "";
  const raw = rawSlug == null ? "" : String(rawSlug);
  if (slugMap[clean] !== raw) {
    // When two posts clean to the same slug, the build gives the later one "<clean>-<id>".
    const suffixed = Object.keys(slugMap).find(
      (key) => key.startsWith(`${clean}-`) && slugMap[key] === raw
    );
    if (suffixed) return `/blogs/${suffixed}`;
  }
  return `/blogs/${clean}`;
}

/**
 * Maps a URL slug to the slug the API stores. `mapped` is false for posts that
 * were published after the last build; their API slug has to be looked up.
 */
export function resolveBlogPath(pathSlug) {
  const decoded = safeDecode(pathSlug);
  if (Object.prototype.hasOwnProperty.call(slugMap, decoded)) {
    return { raw: slugMap[decoded], redirectTo: null, mapped: true };
  }
  const cleanKey = Object.keys(slugMap).find((key) => slugMap[key] === decoded);
  if (cleanKey && cleanKey !== decoded) {
    return { raw: slugMap[cleanKey], redirectTo: `/blogs/${cleanKey}`, mapped: true };
  }
  return { raw: decoded, redirectTo: null, mapped: false };
}

export function withImageAlts(html, altText) {
  if (!html) return "";
  const alt = String(altText || "Connct blog image")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;");
  return html.replace(/<img\b([^>]*?)>/gi, (tag, attrs) => {
    const altMatch = attrs.match(/\balt\s*=\s*(['"])([\s\S]*?)\1/i);
    if (altMatch && altMatch[2].trim()) return tag;
    const withoutAlt = attrs.replace(/\s*\balt\s*=\s*(['"])[\s\S]*?\1/i, "");
    return `<img alt="${alt}"${withoutAlt}>`;
  });
}

/** Keep a single page H1. Article HTML from the CMS is rendered below that heading. */
export function prepareBlogHtml(html, altText) {
  return withImageAlts(html, altText)
    .replace(/<h1\b/gi, "<h2")
    .replace(/<\/h1>/gi, "</h2>");
}

export function usableMeta(value) {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || /^(null|undefined)$/i.test(text)) return "";
  return text;
}
